import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../../components/dropdown/MultiSelectDropdown";

export const ProcessRatesPopUp = (props) => {

    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <span className="text-blue text-[16px] font-semibold">Item master rate details</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-5 pb-[10px] border-b border-slate-200'>
                    <div className='input-grp'>
                        <label>Process name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select process"
                            options={props.processObject.processList}
                            value={props.processObject.idProcess ? props.processObject.processList.find(x => x.value === props.processObject.idProcess) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idProcess")
                            }
                            className={props.validState?.error?.idProcess !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        {/* <label>Item category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select category"
                            options={props.processObject.itemCategoryList}
                            value={props.processObject.idItemCategory ? props.processObject.itemCategoryList.find(x => x.value === props.processObject.idItemCategory) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idItemCategory")
                            }
                            className={props.validState?.error?.idItemCategory !== undefined ? "error" : ""}
                        /> */}
                    </div>
                    <div className='btn-grp flex gap-2.5'>
                        <button className="save-btn btns" onClick={() => props.submit()}>Submit</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Clear</button>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                {(() => {
                    const activeTab = props.processObject.activeTab || "pending";
                    const pendingRows = props.processObject.processRowData || [];
                    const selectedRows = props.processObject.processSelectedRowData || [];
                    const isPending = activeTab === "pending";
                    const tabBase = "px-[16px] py-[6px] text-[14px] font-semibold rounded-t-[6px] border border-b-0 cursor-pointer";
                    const activeCls = "bg-blue text-white border-blue";
                    const inactiveCls = "bg-slate-100 text-slate-600 border-slate-200";
                    return (
                        <>
                            <div className="tabs flex gap-1 mt-2.5">
                                <button
                                    type="button"
                                    className={`${tabBase} ${isPending ? activeCls : inactiveCls}`}
                                    onClick={() => props.setActiveTab("pending")}
                                >
                                    Pending ({pendingRows.length})
                                </button>
                                <button
                                    type="button"
                                    className={`${tabBase} ${!isPending ? activeCls : inactiveCls}`}
                                    onClick={() => props.setActiveTab("selected")}
                                >
                                    Selected ({selectedRows.length})
                                </button>
                            </div>
                            <div className="process-table h-[50vh]">
                                <div className="table-inner h-full">
                                    <AgGridReact
                                        rowData={isPending ? pendingRows : selectedRows}
                                        columnDefs={isPending ? props.processObject.processColdefs : props.processObject.processSelectedColdefs}
                                        onCellClicked={props.handleCellClickItemList}
                                        rowSelection={props.rowSelection}
                                        onRowClicked={props.onRowClicked}
                                        onCellValueChanged={props.onCellValueChanged}
                                        stopEditingWhenCellsLoseFocus={true}
                                        onGridReady={props.onGridReady}
                                        onRowDoubleClicked={isPending ? undefined : props.onSelectedRowDoubleClicked}
                                    />
                                </div>
                            </div>
                        </>
                    );
                })()}
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.save()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>
        </ModalBasic>
    );
}